import React, { useEffect, useState } from 'react';
import { BillingAccountsVService, ServiceStatusEnum, TransactionsVService } from '../../../services/V2/gozer';
import { CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid } from '@material-ui/core';
import { AccountSearch } from '../../shared/AccountSearch';
import { dateToLocal, formatMoney, handleErrorToast } from '../../shared/Functions';
import SearchIcon from '@material-ui/icons/Search';
import { DistrictsVService } from '../../../services/V2/padre';
import { ConfirmModal } from '../../shared/ConfirmModal';

export const TransferPayment = ({ setShowTransfer, transaction, errorToast, successToast, operatorId, setRefresh }) => {
    const [fromAccount, setFromAccount] = useState<any>();
    const [toAccount, setToAccount] = useState<any>();
    const [toAccountId, setToAccountId] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [showSearch, setShowSearch] = useState<boolean>(false);
    const [districts, setDistricts] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [model, setModel] = useState<any>();
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);
    const disallowedStatuses = [ServiceStatusEnum.NEW1UP,ServiceStatusEnum.NEW_ACCOUNT,ServiceStatusEnum.INACTIVE,ServiceStatusEnum.SERVICE_ADDRESS]

    useEffect(() => {
        if(!transaction) return;
        setLoading(true)
        BillingAccountsVService.billingAccountsVGetById(transaction.billingAccountId)
            .then((x: any) => {
                setFromAccount(x)
                setDistrictId(x.districtId)
                setLoading(false)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }, [transaction])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!toAccountId) return;
        if (toAccountId === fromAccount.id) {
            errorToast("Destination account cannot be the same as original account. Please choose a different account.");
            return;
        }
        setLoading(true)
        BillingAccountsVService.billingAccountsVGetById(toAccountId)
            .then((x: any) => {
                setToAccount(x);
                setLoading(false);
                
                if (disallowedStatuses.find(y => y === x.serviceStatus)) {
                    errorToast("Destination account is ineligible for transfers due to its status. Please choose a different account.");
                }
                else {
                    setSubmitDisabled(false);
                }
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }, [toAccountId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!districtId) return;
		setLoading(true)
		DistrictsVService.districtsVGetById(districtId)
		.then((x: any) => {
			setDistricts([{id: x.id, name: x.name }])
            setLoading(false)
		})
		.catch((x) => {setLoading(false)});
	}, 	[districtId]);// eslint-disable-line react-hooks/exhaustive-deps

    const submitTransfer = () => {
        setLoading(true)
        setShowConfirm(false)
        TransactionsVService.transactionsVTransferPayment(fromAccount.id, transaction.transactionId, toAccountId)
        .then((x: any) => {
            successToast("Transfer completed")
            setLoading(false)
            setShowTransfer(false)
            setRefresh(true)
        })
        .catch(x => {
            errorToast(handleErrorToast(x))
            setLoading(false)
        })
    }

    const handleSubmit = () => {
        if (!toAccountId) {
            errorToast("Please select an account to transfer to and try again.")
        }

        else {
            setShowConfirm(true)
        }
    }

    return (
        <>
            {showSearch &&
                <AccountSearch
                    isOpen={showSearch} 
                    handleClose={() => setShowSearch(false)}
                    operatorId={operatorId}
                    districts={districts}
                    listingModel={model}
                    setListingModel={setModel}
                    setBillingAccountId={setToAccountId}
                    forceDistrictSelection={true} />
            }
            <ConfirmModal
                cancelCallback={() => setShowConfirm(false)}
                show={showConfirm}
                confirmCallback={submitTransfer}
                title={"Submit Transfer"}
                description={"Are you sure you want to transfer this payment?"}
                fullWidth />
            <Dialog
                fullScreen
                open={true}
                onClose={() => setShowTransfer(false)}
                aria-labelledby="form-dialog-title"
                style={{ margin: "20px" }}
            >
                <DialogTitle id="form-dialog-title" style={{ textAlign: "left" }}>
                    Transfer Misapplied Payment
                </DialogTitle>
                <Divider />
                <DialogContent style={{ padding: "8px 0px 0px 0px" }}>
                    <Grid container>
                        <Grid item xs={12} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>Confirmation Number</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="confirmationNumber"
                                        name="confirmationNumber"
                                        value={transaction?.confirmationNumber}
                                        disabled />
                                </label>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>Payment Date</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="paymentDate"
                                        name="paymentDate"
                                        value={dateToLocal(transaction?.paymentDate).toLocaleString()}
                                        disabled />
                                </label>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="paymentAmount"
                                        name="paymentAmount"
                                        value={formatMoney(transaction?.paymentAmount)}
                                        disabled />
                                </label>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>Service Fee</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="feeAmount"
                                        name="feeAmount"
                                        value={formatMoney(transaction?.feeAmount)}
                                        disabled />
                                </label>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container style={{ backgroundColor: "#f5f5f5", height: "30px" }}></Grid>
                    <Grid container>
                        <Grid item xs={4} style={{ margin: "20px 0px" }}>
                            <div style={{ fontSize: "16", fontWeight: "bold" }}>
                                From Account
                            </div>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4} style={{ margin: "20px 0px" }}>
                            <div style={{ fontSize: "16", fontWeight: "bold" }}>
                                To Account
                            </div>
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Account</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="fromAccountNumber"
                                        name="fromAccountNumber"
                                        value={fromAccount?.accountNumber}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Name</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="fromName"
                                        name="fromName"
                                        value={fromAccount?.customer.fullName}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Service Address</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="fromServiceAddress" 
                                        name="fromServiceAddress"
                                        value={fromAccount?.services[0]?.serviceAddress?.street}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>City</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="fromCity" 
                                        name="fromCity"
                                        value={fromAccount?.services[0]?.serviceAddress?.city}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>State</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "50px" }} 
                                        type="text" 
                                        id="fromState" 
                                        name="fromState"
                                        value={fromAccount?.services[0]?.serviceAddress?.state}
                                        disabled />
                                </label>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Zip Code</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "118px" }} 
                                        type="text" 
                                        id="fromZip" 
                                        name="fromZip"
                                        value={fromAccount?.services[0]?.serviceAddress?.zip}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Account Status</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="fromServiceStatus" 
                                        name="fromServiceStatus"
                                        value={fromAccount?.serviceStatus}
                                        disabled />
                                </label>
                            </div>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Account</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="toAccountNumber"
                                        name="toAccountNumber"
                                        value={toAccount?.accountNumber}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Name</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        type="text"
                                        id="toName"
                                        name="toName"
                                        value={toAccount?.customer.fullName}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Service Address</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="toServiceAddress" 
                                        name="toServiceAddress"
                                        value={toAccount?.services[0]?.serviceAddress?.street}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>City</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="toCity" 
                                        name="toCity"
                                        value={toAccount?.services[0]?.serviceAddress?.city}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>State</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "50px" }} 
                                        type="text" 
                                        id="toState" 
                                        name="toState"
                                        value={toAccount?.services[0]?.serviceAddress?.state}
                                        disabled />
                                </label>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Zip Code</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "118px" }} 
                                        type="text" 
                                        id="toZip" 
                                        name="toZip"
                                        value={toAccount?.services[0]?.serviceAddress?.zip}
                                        disabled />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px' }}>
                                    <b>Account Status</b><span>&nbsp;:&nbsp;</span>
                                    <input 
                                        className='uvp-input' 
                                        style={{ width: "250px" }} 
                                        type="text" 
                                        id="toServiceStatus" 
                                        name="toServiceStatus"
                                        value={toAccount?.serviceStatus}
                                        disabled />
                                </label>
                            </div>
                        </Grid>
                        <Grid item xs={2} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px', height: "30px" }}>
                                    <button className='uvp-search-button' onClick={() => setShowSearch(true)}><SearchIcon /></button>
                                </label>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} style={{ alignSelf: "flex-end", textAlign: "right", margin: "40px 20px 0px 0px" }}>
                            <button
                                className='uvp-button green-button'
                                type="button"
                                disabled={submitDisabled}
                                onClick={handleSubmit}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                }}
                            >
                                Submit
                            </button>
                            <button
                                className='uvp-button gray-button'
                                type="button"
                                onClick={() => setShowTransfer(false)}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                }}
                            >
                                Close
                            </button>
                        </Grid>
                    </Grid>
                </DialogContent>
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
            </Dialog>
        </>
    )
}